"use client";

import { isPossibleToJoin } from "../../utils/tournaments";
import { useUI } from "../../context/UIContext";
import Tabs from "../Tabs";
import { Tab } from "@/types/tabs";
import { PageBannerBlok } from "@/types/sb-types";
import Cta from "../Cta";
import dayjs from "dayjs";
import { StoryblokComponent } from "@storyblok/react";

interface TournamentPageTabs {
  tournamentId: string;
  season: number;
  name: string;
  playersCount: number;
  signUpStartTime: string;
  signUpEndTime: string;
  signupUri: string;
  tabs: Tab[];
  slug: string;
  isEarnings: boolean;
  logo?: string;
  banner?: PageBannerBlok;
}

const TournamentPageTabs = ({
  name,
  playersCount,
  signUpStartTime,
  signUpEndTime,
  signupUri,
  tabs,
  slug,
  isEarnings,
  banner,
}: // logo,
TournamentPageTabs) => {
  const { dispatch } = useUI();

  const signupStart = dayjs(signUpStartTime);
  const signupEnd = dayjs(signUpEndTime);
  const currentDate = dayjs();

  const tabsToRender = isEarnings
    ? tabs
    : tabs.filter((tab) => tab.slug !== "earnings");

  return (
    <>
      {banner ? (
        <StoryblokComponent blok={banner} />
      ) : (
        <div className="flex flex-col items-center gap-2 md:gap-4">
          <h1 className="px-5 md:px-12.5 text-center text-2xl md:text-4xl 2xl:text-5xl">
            {name}
          </h1>
          <span
            aria-hidden
            className="block w-full h-0.5 bg-linear-to-r from-[rgba(21,20,20,0)] via-tm-c-brand to-[rgba(21,20,20,0)]"
          />
        </div>
      )}
      <div>
        {tabs?.length > 0 && (
          <Tabs tabs={tabsToRender} pageSlug={`tournament/${slug}`}>
            {signUpStartTime &&
              signUpEndTime &&
              currentDate.isAfter(signupStart) &&
              currentDate.isBefore(signupEnd) &&
              isPossibleToJoin(playersCount) &&
              signupUri && (
                <Cta
                  name="Join"
                  onClick={() => {
                    window.localStorage.setItem("next_signup_uri", signupUri);
                    dispatch({
                      type: "toggleJoinFlowInfoModal",
                      payload: {
                        isOpen: true,
                        title: name,
                        modalType: "signup",
                      },
                    });
                  }}
                />
              )}
          </Tabs>
        )}
      </div>
    </>
  );
};

export default TournamentPageTabs;
